/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';
import _ from 'underscore';

// @ts-expect-error
import BenchlingData from 'util/drag-and-drop/BenchlingData';

const {TFI_MIME_TYPE} = BenchlingData;

interface Props {
  tfiObject: any;
}

class TFIDragTarget extends React.Component<Props> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  dragStartHandler = (e: any) => {
    // eslint-disable-next-line new-cap
    const bd = BenchlingData(e);
    e.dataTransfer.effectAllowed = 'all';
    e.dataTransfer.dropEffect = 'move';

    const tfiJSON = {
      id: this.props.tfiObject.id,
      accountId: this.props.tfiObject.accountId,
      name: this.props.tfiObject.name,
      accountType: this.props.tfiObject.accountType,
    };
    bd.setData(TFI_MIME_TYPE, tfiJSON);
  };

  render(): JSX.Element {
    return (
      <div
        // eslint-disable-next-line no-restricted-syntax
        {..._.extend({}, _.omit(this.props, 'tfiObject'), {
          draggable: true,
          onDragStart: this.dragStartHandler,
        })}
      >
        {this.props.children}
      </div>
    );
  }
}

export default TFIDragTarget;
